import React from 'react';
import { Link } from 'react-router-dom';
import { IconButton } from '@rmwc/icon-button';
import { Tooltip } from '@rmwc/tooltip';

import '../../css/dashboard/dashboard-theme.css';
import '../../css/public-navigation.css';
import '@rmwc/icon-button/styles';
import '@rmwc/tooltip/styles';

function NavigationLink({ item }) {
  if (item.href) return <a href={item.href}>{item.label}</a>;
  return <Link to={item.to}>{item.label}</Link>;
}

function PublicNavigation({
  brand = 'GoldAPI.io',
  links = [],
  isDarkMode = false,
  onToggleDarkMode,
  useLightThemeLabel = 'Use light theme',
  useDarkThemeLabel = 'Use dark theme',
  ariaLabel = 'Primary navigation'
}) {
  const themeLabel = isDarkMode ? useLightThemeLabel : useDarkThemeLabel;

  return (
    <nav className="public-navigation" aria-label={ariaLabel}>
      <Link className="public-navigation-brand" to="/">
        <img src="/logo.svg" alt="" />
        {brand}
      </Link>
      <div className="public-navigation-actions">
        {links.map(item => <NavigationLink item={item} key={item.href || item.to} />)}
        {onToggleDarkMode && <Tooltip content={themeLabel}>
          <IconButton
            icon={isDarkMode ? 'light_mode' : 'dark_mode'}
            className="dashboard-theme-toggle public-navigation-theme-toggle"
            aria-label={themeLabel}
            aria-pressed={isDarkMode}
            onClick={onToggleDarkMode}
          />
        </Tooltip>}
      </div>
    </nav>
  );
}

export default PublicNavigation;
